var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grid is-col-min-15" }, [
    _c("div", { staticClass: "cell is-flex" }, [
      _c("div", { staticClass: "is-flex-grow-1 is-flex" }, [
        _c("article", { staticClass: "box is-flex-grow-1" }, [
          _c("div", { staticClass: "columns" }, [
            _vm._m(0),
            _c("div", { staticClass: "column is-narrow" }, [
              !_vm.isLoadingInvoice
                ? _c("div", { staticClass: "buttons" }, [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.$user.hasEdit(_vm.$route.meta.id) &&
                              !_vm.readOnlyView &&
                              !_vm.isUpdateExcessInvoice &&
                              _vm.invoice &&
                              !_vm.invoice.gstPaidDate,
                            expression:
                              "$user.hasEdit($route.meta.id) && !readOnlyView && !isUpdateExcessInvoice && invoice && !invoice.gstPaidDate",
                          },
                        ],
                        staticClass: "button tooltip is-tooltip-bottom",
                        attrs: { "data-tooltip": "Update Invoice" },
                        on: {
                          click: function ($event) {
                            return _vm.editInvoice()
                          },
                        },
                      },
                      [_vm._m(1)]
                    ),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showSave,
                            expression: "showSave",
                          },
                        ],
                        staticClass: "button tooltip is-tooltip-bottom",
                        attrs: { "data-tooltip": "Save Changes" },
                        on: {
                          click: function ($event) {
                            return _vm.saveInvoice()
                          },
                        },
                      },
                      [_vm._m(2)]
                    ),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.$user.hasAdd(_vm.$route.meta.id) &&
                              !_vm.readOnlyView &&
                              !_vm.invoice,
                            expression:
                              "$user.hasAdd($route.meta.id) && !readOnlyView && !invoice",
                          },
                        ],
                        staticClass: "button tooltip is-tooltip-bottom",
                        attrs: { "data-tooltip": "New Invoice" },
                        on: {
                          click: function ($event) {
                            return _vm.addInvoice()
                          },
                        },
                      },
                      [_vm._m(3)]
                    ),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              (_vm.$user.hasDelete(_vm.$route.meta.id) &&
                                !_vm.readOnlyView &&
                                !_vm.isUpdateExcessInvoice &&
                                _vm.invoice &&
                                !_vm.invoice.gstPaidDate) ||
                              (_vm.invoice && _vm.invoice.isNew),
                            expression:
                              "$user.hasDelete($route.meta.id) && !readOnlyView && !isUpdateExcessInvoice && invoice && !invoice.gstPaidDate || (invoice && invoice.isNew)",
                          },
                        ],
                        staticClass: "button tooltip is-tooltip-bottom",
                        attrs: { "data-tooltip": "Delete Invoice" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteInvoice(_vm.invoice.invoiceType)
                          },
                        },
                      },
                      [_vm._m(4)]
                    ),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.$user.hasEdit(_vm.$route.meta.id) &&
                              _vm.isUpdateExcessInvoice &&
                              _vm.invoice &&
                              !_vm.invoice.isNew,
                            expression:
                              "$user.hasEdit($route.meta.id) && isUpdateExcessInvoice && invoice && !invoice.isNew",
                          },
                        ],
                        staticClass: "button tooltip is-tooltip-bottom",
                        attrs: { "data-tooltip": "Update from quote" },
                        on: {
                          click: function ($event) {
                            return _vm.updateInvoice()
                          },
                        },
                      },
                      [_vm._m(5)]
                    ),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.$user.hasEdit(_vm.$route.meta.id) &&
                              _vm.isUpdateExcessInvoice &&
                              _vm.invoice &&
                              !_vm.invoice.isNew,
                            expression:
                              "$user.hasEdit($route.meta.id) && isUpdateExcessInvoice && invoice && !invoice.isNew",
                          },
                        ],
                        staticClass: "button tooltip is-tooltip-bottom",
                        attrs: { "data-tooltip": "Cancel" },
                        on: {
                          click: function ($event) {
                            return _vm.cancelInvoice()
                          },
                        },
                      },
                      [_vm._m(6)]
                    ),
                  ])
                : _vm._e(),
              _vm.invoice && _vm.invoice.gstPaidDate
                ? _c(
                    "span",
                    {
                      staticClass:
                        "tag is-warning is-pulled-right tooltip is-tooltip-warning",
                      attrs: { "data-tooltip": "GST has been paid" },
                    },
                    [
                      _vm._v(
                        "GST paid on " +
                          _vm._s(
                            _vm.$filters.formatDateTimezone(
                              _vm.invoice.gstPaidDate,
                              _vm.$userInfo.locale
                            )
                          )
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          !_vm.invoice && _vm.isLoadingInvoice
            ? _c("div", { staticClass: "section" }, [
                _c("span", {
                  staticClass:
                    "is-loading-image has-text-grey has-text-centered",
                }),
              ])
            : _vm.invoice
            ? _c("div", [
                _c("div", { staticClass: "field-body" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Invoice No."),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        staticClass: "input is-static",
                        attrs: {
                          type: "text",
                          placeholder: "Invoice No.",
                          readonly: "",
                        },
                        domProps: { value: _vm.invoiceNoReference },
                      }),
                    ]),
                  ]),
                  !_vm.isUpdateExcessInvoice
                    ? _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Invoice Date"),
                        ]),
                        _c("input", {
                          staticClass: "input is-static",
                          attrs: { readonly: "" },
                          domProps: {
                            value: _vm.$filters.formatDateTimezone(
                              _vm.selectedInvoiceDate,
                              _vm.$userInfo.locale
                            ),
                          },
                        }),
                      ])
                    : _vm.$userInfo && !_vm.gstPaid && _vm.selectedInvoiceDate
                    ? _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Invoice Date"),
                          ]),
                          _c("v-date-picker", {
                            attrs: {
                              "is-dark": _vm.$theme.isDark,
                              masks: _vm.formats,
                              attributes: _vm.attrs,
                              locale: _vm.$userInfo.locale,
                              "min-date": _vm.firstDayOfMonth,
                              timezone: _vm.$filters.getIanaTimezone(),
                            },
                            on: { input: _vm.invoiceDateInputEvent },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ inputValue, inputEvents }) {
                                  return [
                                    _c("div", { staticClass: "field" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "control has-icons-left",
                                        },
                                        [
                                          _c(
                                            "input",
                                            _vm._g(
                                              {
                                                staticClass: "input",
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "Date To...",
                                                  readonly: "",
                                                },
                                                domProps: { value: inputValue },
                                              },
                                              inputEvents
                                            )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "icon is-small is-left",
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "mdi mdi-calendar mdi-18px",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.selectedInvoiceDate,
                              callback: function ($$v) {
                                _vm.selectedInvoiceDate = $$v
                              },
                              expression: "selectedInvoiceDate",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "is-divider" }),
                !_vm.isUpdateExcessInvoice
                  ? _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [_vm._v("Payer")]),
                      _c("input", {
                        staticClass: "input is-static",
                        attrs: { type: "text", readonly: "" },
                        domProps: { value: _vm.invoice.assetName },
                      }),
                    ])
                  : _vm._e(),
                _vm.isUpdateExcessInvoice && _vm.isThirdPartyPayer
                  ? _c("div", { staticClass: "field" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "is-flex is-justify-content-space-between",
                        },
                        [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Payer"),
                          ]),
                          _c("div", { staticClass: "is-flex" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "is-flex is-align-items-center is-justify-content-end mb-2",
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "pretty-checkbox-label pr-1 is-size-7",
                                    attrs: { for: "chk-customer" },
                                  },
                                  [_vm._v("Customer")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pretty p-icon p-round p-smooth m-0",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.assetFilter.showCustomer,
                                          expression:
                                            "assetFilter.showCustomer",
                                        },
                                      ],
                                      attrs: {
                                        id: "chk-customer",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.assetFilter.showCustomer
                                        )
                                          ? _vm._i(
                                              _vm.assetFilter.showCustomer,
                                              null
                                            ) > -1
                                          : _vm.assetFilter.showCustomer,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.assetFilter.showCustomer,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.assetFilter,
                                                  "showCustomer",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.assetFilter,
                                                  "showCustomer",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.assetFilter,
                                              "showCustomer",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._m(7),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "is-flex is-align-items-center is-justify-content-end mb-2 pl-2",
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "pretty-checkbox-label pr-1 is-size-7",
                                    attrs: { for: "chk-insurer" },
                                  },
                                  [_vm._v("Insurer")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pretty p-icon p-round p-smooth m-0",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.assetFilter.showInsurer,
                                          expression: "assetFilter.showInsurer",
                                        },
                                      ],
                                      attrs: {
                                        id: "chk-insurer",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.assetFilter.showInsurer
                                        )
                                          ? _vm._i(
                                              _vm.assetFilter.showInsurer,
                                              null
                                            ) > -1
                                          : _vm.assetFilter.showInsurer,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.assetFilter.showInsurer,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.assetFilter,
                                                  "showInsurer",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.assetFilter,
                                                  "showInsurer",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.assetFilter,
                                              "showInsurer",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._m(8),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "control is-expanded" },
                        [
                          _vm.assets
                            ? _c(
                                "multiselect",
                                {
                                  class: {
                                    "is-danger": _vm.$v.entity.invoices.$error,
                                  },
                                  attrs: {
                                    "deselect-label": "Can't remove this value",
                                    "track-by": "assetId",
                                    label: "assetName",
                                    placeholder: "Select a payer",
                                    options: _vm.assets,
                                    loading: _vm.isAssetLoading,
                                    "internal-search": false,
                                    "options-limit": _vm.assetFilter.pageSize,
                                    searchable: true,
                                    "show-labels": false,
                                    "allow-empty": true,
                                  },
                                  on: {
                                    select: _vm.selectAsset,
                                    remove: _vm.removeAsset,
                                    "search-change": _vm.getAssetDropdownFilter,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "option",
                                        fn: function (props) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "tag is-pulled-right",
                                                class: {
                                                  "is-success":
                                                    props.option.assetType == 1,
                                                  "is-info":
                                                    props.option.assetType == 4,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.option.assetType ==
                                                        1
                                                        ? "Customer"
                                                        : "Insurer"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  `${props.option.assetName}`
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2502510241
                                  ),
                                  model: {
                                    value: _vm.selectedAsset,
                                    callback: function ($$v) {
                                      _vm.selectedAsset = $$v
                                    },
                                    expression: "selectedAsset",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "has-text-danger",
                                      attrs: { slot: "noResult" },
                                      slot: "noResult",
                                    },
                                    [_vm._v("Payer not found.")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.$v.entity && _vm.$v.entity.invoices.$error
                            ? _c("span", { staticClass: "help is-danger" }, [
                                _vm._v("Payer is required."),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm.isUpdateExcessInvoice
                  ? _c("div", { staticClass: "field" }, [
                      !_vm.isThirdPartyPayer
                        ? _c("label", { staticClass: "label" }, [
                            _vm._v("Payer"),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "control" }, [
                        _c("div", [
                          _c(
                            "label",
                            {
                              staticClass:
                                "pretty-checkbox-label pr-1 is-size-7",
                              attrs: { for: "chk-invoiceExcessWithGst" },
                            },
                            [_vm._v("3rd Party")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "pretty p-icon p-round p-smooth m-0",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.isThirdPartyPayer,
                                    expression: "isThirdPartyPayer",
                                  },
                                ],
                                attrs: {
                                  id: "chk-thirdParty",
                                  type: "checkbox",
                                },
                                domProps: {
                                  value: _vm.invoicePayerTypes.ThirdParty,
                                  checked: Array.isArray(_vm.isThirdPartyPayer)
                                    ? _vm._i(
                                        _vm.isThirdPartyPayer,
                                        _vm.invoicePayerTypes.ThirdParty
                                      ) > -1
                                    : _vm.isThirdPartyPayer,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = _vm.isThirdPartyPayer,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v =
                                            _vm.invoicePayerTypes.ThirdParty,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.isThirdPartyPayer = $$a.concat(
                                              [$$v]
                                            ))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.isThirdPartyPayer = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.isThirdPartyPayer = $$c
                                      }
                                    },
                                    function ($event) {
                                      return _vm.onInvoicePayerTypeClick(
                                        _vm.invoicePayerTypes.ThirdParty
                                      )
                                    },
                                  ],
                                },
                              }),
                              _vm._m(9),
                            ]
                          ),
                        ]),
                      ]),
                      !_vm.customerAsset
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v(
                              "Private invoice disabled. Customer has been deleted"
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field-body" }, [
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-justify-content-space-between",
                            },
                            [
                              _c("label", { staticClass: "label" }, [
                                _vm._v("Excess"),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "is-flex is-align-items-center is-justify-content-end mb-2",
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "pr-1 is-size-7",
                                      class: {
                                        "pretty-checkbox-label":
                                          !_vm.disableExcessWithGst,
                                      },
                                      attrs: {
                                        for: "chk-invoiceExcessWithGst",
                                      },
                                    },
                                    [_vm._v("Excess with GST")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pretty p-icon p-round p-smooth m-0",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.excessWithGst,
                                            expression: "excessWithGst",
                                          },
                                        ],
                                        attrs: {
                                          id: "chk-invoiceExcessWithGst",
                                          type: "checkbox",
                                          disabled: _vm.disableExcessWithGst,
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.excessWithGst
                                          )
                                            ? _vm._i(_vm.excessWithGst, null) >
                                              -1
                                            : _vm.excessWithGst,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.excessWithGst,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.excessWithGst =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.excessWithGst = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.excessWithGst = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._m(10),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              "min:": 0,
                              precision: 2,
                              disabled:
                                !_vm.isUpdateExcessInvoice ||
                                _vm.hasQuoteInvoice,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateTotal()
                              },
                            },
                            model: {
                              value: _vm.invoice.excessAmount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.invoice,
                                  "excessAmount",
                                  _vm._n($$v)
                                )
                              },
                              expression: "invoice.excessAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    !_vm.hasOcInvoice
                      ? _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c("label", { staticClass: "label" }, [
                              _vm._v("Owner Contribution"),
                            ]),
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                "min:": 0,
                                precision: 2,
                                disabled: _vm.disableOwnerContribution,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.updateTotal()
                                },
                                blur: function ($event) {
                                  return _vm.onBlurOwnersContribution()
                                },
                              },
                              model: {
                                value: _vm.ownersContribution,
                                callback: function ($$v) {
                                  _vm.ownersContribution = _vm._n($$v)
                                },
                                expression: "ownersContribution",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
                !_vm.hasOcInvoice
                  ? _c("div", { staticClass: "field" }, [
                      _c("div", { staticClass: "field-body" }, [
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c("label", { staticClass: "label" }, [
                              _vm._v("Extra Charge"),
                            ]),
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                "min:": 0,
                                precision: 2,
                                disabled: !_vm.isUpdateExcessInvoice,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.updateTotal()
                                },
                                blur: function ($event) {
                                  return _vm.onBlurExtraCharge()
                                },
                              },
                              model: {
                                value: _vm.extraCharge,
                                callback: function ($$v) {
                                  _vm.extraCharge = _vm._n($$v)
                                },
                                expression: "extraCharge",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c("label", { staticClass: "label" }, [
                              _vm._v("GST"),
                            ]),
                            _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                "min:": 0,
                                precision: 2,
                                disabled: !_vm.isUpdateExcessInvoice,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.updateTotal(false)
                                },
                              },
                              model: {
                                value: _vm.invoice.gst,
                                callback: function ($$v) {
                                  _vm.$set(_vm.invoice, "gst", _vm._n($$v))
                                },
                                expression: "invoice.gst",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Remarks")]),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.invoice.invoiceRemark,
                        expression: "invoice.invoiceRemark",
                      },
                    ],
                    staticClass: "textarea",
                    attrs: {
                      placeholder: "",
                      disabled: !_vm.isUpdateExcessInvoice,
                      rows: "3",
                    },
                    domProps: { value: _vm.invoice.invoiceRemark },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.invoice,
                          "invoiceRemark",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.invoice.exported,
                          expression: "invoice.exported",
                        },
                      ],
                      staticClass: "is-checkradio",
                      attrs: {
                        type: "checkbox",
                        id: "invoice-exported",
                        disabled:
                          _vm.readOnlyView ||
                          !_vm.$userInfo.isSupportUser ||
                          !_vm.isUpdateExcessInvoice,
                      },
                      domProps: {
                        checked: Array.isArray(_vm.invoice.exported)
                          ? _vm._i(_vm.invoice.exported, null) > -1
                          : _vm.invoice.exported,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.invoice.exported,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.invoice,
                                  "exported",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.invoice,
                                  "exported",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.invoice, "exported", $$c)
                          }
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "invoice-exported" } }, [
                      _vm._v("Exported"),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Total Excl GST: "),
                    _c("span", { staticClass: "has-text-success" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.totalExGst,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Total Payable Incl GST: "),
                    _c("span", { staticClass: "has-text-success" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.totalPayableIncGst,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm.hasOcInvoice
      ? _c("div", { staticClass: "cell is-flex" }, [
          _c("article", { staticClass: "box is-flex-grow-1" }, [
            _c("div", { staticClass: "columns" }, [
              _vm._m(11),
              _c("div", { staticClass: "column is-narrow" }, [
                !_vm.isLoadingInvoice
                  ? _c("div", { staticClass: "buttons" }, [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.$user.hasEdit(_vm.$route.meta.id) &&
                                !_vm.readOnlyView &&
                                !_vm.isUpdateExcessInvoice &&
                                _vm.ocInvoice &&
                                !_vm.ocInvoice.gstPaidDate,
                              expression:
                                "$user.hasEdit($route.meta.id) && !readOnlyView && !isUpdateExcessInvoice && ocInvoice && !ocInvoice.gstPaidDate",
                            },
                          ],
                          staticClass: "button tooltip is-tooltip-bottom",
                          attrs: { "data-tooltip": "Update Invoice" },
                          on: {
                            click: function ($event) {
                              return _vm.editInvoice()
                            },
                          },
                        },
                        [_vm._m(12)]
                      ),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.$user.hasAdd(_vm.$route.meta.id) &&
                                !_vm.readOnlyView &&
                                !_vm.ocInvoice,
                              expression:
                                "$user.hasAdd($route.meta.id) && !readOnlyView && !ocInvoice",
                            },
                          ],
                          staticClass: "button tooltip is-tooltip-bottom",
                          attrs: { "data-tooltip": "New Invoice" },
                          on: {
                            click: function ($event) {
                              return _vm.addInvoice()
                            },
                          },
                        },
                        [_vm._m(13)]
                      ),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.$user.hasDelete(_vm.$route.meta.id) &&
                                  !_vm.readOnlyView &&
                                  !_vm.isUpdateExcessInvoice &&
                                  _vm.ocInvoice &&
                                  !_vm.ocInvoice.gstPaidDate) ||
                                (_vm.ocInvoice && _vm.ocInvoice.isNew),
                              expression:
                                "$user.hasDelete($route.meta.id) && !readOnlyView && !isUpdateExcessInvoice && ocInvoice && !ocInvoice.gstPaidDate || (ocInvoice && ocInvoice.isNew)",
                            },
                          ],
                          staticClass: "button tooltip is-tooltip-bottom",
                          attrs: { "data-tooltip": "Delete Invoice" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteInvoice(
                                _vm.ocInvoice.invoiceType
                              )
                            },
                          },
                        },
                        [_vm._m(14)]
                      ),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.$user.hasEdit(_vm.$route.meta.id) &&
                                _vm.isUpdateExcessInvoice &&
                                _vm.ocInvoice &&
                                !_vm.ocInvoice.isNew,
                              expression:
                                "$user.hasEdit($route.meta.id) && isUpdateExcessInvoice && ocInvoice && !ocInvoice.isNew",
                            },
                          ],
                          staticClass: "button tooltip is-tooltip-bottom",
                          attrs: { "data-tooltip": "Update from quote" },
                          on: {
                            click: function ($event) {
                              return _vm.updateInvoice()
                            },
                          },
                        },
                        [_vm._m(15)]
                      ),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.$user.hasEdit(_vm.$route.meta.id) &&
                                _vm.isUpdateExcessInvoice &&
                                _vm.ocInvoice &&
                                !_vm.ocInvoice.isNew,
                              expression:
                                "$user.hasEdit($route.meta.id) && isUpdateExcessInvoice && ocInvoice && !ocInvoice.isNew",
                            },
                          ],
                          staticClass: "button tooltip is-tooltip-bottom",
                          attrs: { "data-tooltip": "Cancel" },
                          on: {
                            click: function ($event) {
                              return _vm.cancelInvoice()
                            },
                          },
                        },
                        [_vm._m(16)]
                      ),
                    ])
                  : _vm._e(),
                _vm.ocInvoice && _vm.ocInvoice.gstPaidDate
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "tag is-warning is-pulled-right tooltip is-tooltip-warning",
                        attrs: { "data-tooltip": "GST has been paid" },
                      },
                      [
                        _vm._v(
                          "GST paid on " +
                            _vm._s(
                              _vm.$filters.formatDateTimezone(
                                _vm.ocInvoice.gstPaidDate,
                                _vm.$userInfo.locale
                              )
                            )
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm.ocInvoice
              ? _c("div", [
                  _c("div", { staticClass: "field-body" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Invoice No."),
                      ]),
                      _c("div", { staticClass: "control" }, [
                        _c("input", {
                          staticClass: "input is-static",
                          attrs: {
                            type: "text",
                            placeholder: "Invoice No.",
                            readonly: "",
                          },
                          domProps: { value: _vm.ocInvoiceNoReference },
                        }),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "is-divider" }),
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Owner Contribution"),
                      ]),
                      _c("vue-numeric", {
                        staticClass: "input has-text-right",
                        attrs: {
                          "min:": 0,
                          precision: 2,
                          disabled: _vm.disableOwnerContribution,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.updateTotal()
                          },
                          blur: function ($event) {
                            return _vm.onBlurOwnersContribution()
                          },
                        },
                        model: {
                          value: _vm.ownersContribution,
                          callback: function ($$v) {
                            _vm.ownersContribution = _vm._n($$v)
                          },
                          expression: "ownersContribution",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "field" }, [
                    _c("div", { staticClass: "field-body" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Extra Charge"),
                          ]),
                          _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              "min:": 0,
                              precision: 2,
                              disabled: !_vm.isUpdateExcessInvoice,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateTotal()
                              },
                              blur: function ($event) {
                                return _vm.onBlurExtraCharge()
                              },
                            },
                            model: {
                              value: _vm.extraCharge,
                              callback: function ($$v) {
                                _vm.extraCharge = _vm._n($$v)
                              },
                              expression: "extraCharge",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("GST"),
                          ]),
                          _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: {
                              "min:": 0,
                              precision: 2,
                              disabled: !_vm.isUpdateExcessInvoice,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateTotal(false)
                              },
                            },
                            model: {
                              value: _vm.ocInvoice.gst,
                              callback: function ($$v) {
                                _vm.$set(_vm.ocInvoice, "gst", _vm._n($$v))
                              },
                              expression: "ocInvoice.gst",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [_vm._v("Remarks")]),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ocInvoice.invoiceRemark,
                          expression: "ocInvoice.invoiceRemark",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        placeholder: "",
                        disabled: !_vm.isUpdateExcessInvoice,
                        rows: "3",
                      },
                      domProps: { value: _vm.ocInvoice.invoiceRemark },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.ocInvoice,
                            "invoiceRemark",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm.$userInfo.isSupportUser && _vm.ocInvoice
                    ? _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.ocInvoice.exported,
                                expression: "ocInvoice.exported",
                              },
                            ],
                            staticClass: "is-checkradio",
                            attrs: {
                              type: "checkbox",
                              id: "ocInvoice-exported",
                              disabled: !_vm.isUpdateExcessInvoice,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.ocInvoice.exported)
                                ? _vm._i(_vm.ocInvoice.exported, null) > -1
                                : _vm.ocInvoice.exported,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.ocInvoice.exported,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.ocInvoice,
                                        "exported",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.ocInvoice,
                                        "exported",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.ocInvoice, "exported", $$c)
                                }
                              },
                            },
                          }),
                          _c(
                            "label",
                            { attrs: { for: "ocInvoice-exported" } },
                            [_vm._v("Exported")]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Total Excl GST: "),
                      _c("span", { staticClass: "has-text-success" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              _vm.ocInvoice.totalExGst,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Total Payable Incl GST: "),
                      _c("span", { staticClass: "has-text-success" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              _vm.ocInvoice.totalIncGst,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Excess Invoice")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-pencil mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-content-save mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-refresh mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-warning" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-success" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [
        _vm._v("Owner's Contribution Invoice"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-pencil mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-refresh mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-warning" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }